'use client'

import { useState } from 'react'
import { useRouter } from 'next/navigation'
import { Button } from '@/components/ui/button'

export default function StartSatButton({ children }: { children: React.ReactNode }) {
  const router = useRouter()
  const [busy, setBusy] = useState(false)

  const [error, setError] = useState<string | null>(null)

  return (
    <div>
      <Button
        disabled={busy}
        onClick={async () => {
          try {
            setBusy(true)
            setError(null)
            const r = await fetch('/api/sat/start', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              // No form id: the server picks the form. One sent from the page put
              // the Benchmark form's id in its HTML (practice-pool.ts).
              body: JSON.stringify({}),
            })
            const data = await r.json().catch(() => ({}))
            if (!r.ok) {
              if (r.status === 403) {
                setError(
                  data.message || 'Monthly test limit reached. Upgrade to Pro for unlimited tests.',
                )
              } else {
                setError(data.error || 'Failed to start test. Please try again.')
              }
              return
            }
            router.push(data?.goto ?? '/sat/resume')
          } catch (e) {
            setError('Network error. Please try again.')
          } finally {
            setBusy(false)
          }
        }}
      >
        {busy ? 'Starting…' : children}
      </Button>
      {error && <p className="mt-2 text-sm text-red-400">{error}</p>}
    </div>
  )
}
